import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import axios from 'axios';
import { toast } from 'react-toastify';
import Modal from 'react-bootstrap/Modal';
import TaskJobDetails from './TaskJobDetails';
import authService from './api-authorization/AuthorizeService';

interface JobQuote {
    id: number;
    jobDetails: JobDetails;
    goAheadId: number;
    cancelReasonId: number;         //cancel entire job
    cancelReasons: GenericList[];
    showCancelModal: boolean;
    cancelIndexId: number;
    cancelQuoteItemId: number;
    cancelItemId: number;
    cancelItem: string;
    cancelItemReasonId: number;     //individual quote item
    loading: boolean;
    errors: any;
}

interface JobDetails {
    jobId: number;
    customer: string;
    customerContact: string;
    mobile: string;
    phone: string;
    siteAddress: string;
    lotNumber: string;
    quoteItems: ItemList[];
}

interface ItemList {
    id: number;
    item: string;
    itemId: number;
    status: string;
    hirePeriodDays: string;
    quantityMeasure: string;
    amountFormatted: string;
    overhireRateFormatted: string;
}

interface INameToValueMap {
    [key: string]: any;
}

interface GenericList {
    id: number;
    name: string;
}

export class TaskFollowUpQuoteData extends React.Component<RouteComponentProps<{}>, JobQuote> {
    constructor(props: any) {
        super(props);
        this.state = {
            id: 0,
            jobDetails: {
                jobId: 0,
                customer: "",
                customerContact: "",
                mobile: "",
                phone: "",
                siteAddress: "",
                lotNumber: "",
                quoteItems: []
            },
            goAheadId: -1,
            cancelReasonId: -1,
            cancelReasons: [],
            showCancelModal: false,
            cancelIndexId: 0,
            cancelQuoteItemId: 0,
            cancelItemId: 0,
            cancelItem: "",
            cancelItemReasonId: -1,
            loading: true,
            errors: {}
        };
    }

    componentDidMount() {
        this.getData();
    }

    async getData() {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        let jobParams: INameToValueMap = {};
        jobParams["id"] = 0;
        jobParams = this.props.match.params;
        let Id = jobParams["id"];
        this.setState({ id: Id });

        axios.get('api/User/CheckUserPermission?Permission=RunFollowUpQuoteTask&SubId=' + user.sub, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
            .then(res => {
                if (res.data == true) {
                    //get the list of cancel reasons for any existing jobs 
                    axios.get('api/Job/GetCancelReasons?SubId=' + user.sub, {
                        headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
                    })
                    .then(res => {
                        this.setState({ cancelReasons: res.data })

                        //assign task to current user
                        var taskdetails = {
                            Id: Id,
                            SubId: user.sub
                        };
                        axios.post('api/Tasks/AssignTask', taskdetails, {
                            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
                        })
                        .then(res => {
                            //this needs to just happen in the background
                        });

                        axios.get('api/Tasks/GetTaskFollowUpQuoteDetails?Id=' + Id, {
                            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
                        })
                        .then(res => {
                            this.setState({ id: Id, jobDetails: res.data, loading: false });
                        })
                        .catch(error => {
                            toast.error(error.message);
                        });
                    })
                    .catch(error => {
                        toast.error(error.message);
                    });
                } else {
                    //redirect to 403 permission denied
                    this.props.history.push("/accessdenied")
                }
            })
            .catch(error => {
                toast.error(error.message);
            });
    }

    handleChange = (e: any) => {
        //check if there is a value and an error, and if so remove from error list
        var errors = this.state.errors;
        if (e.target.value) {
            delete errors[e.target.name];
        }

        let change: any = {};
        change[e.target.name] = e.target.value;
        change["errors"] = errors;
        this.setState(change);
    }

    //Cancel Popup
    cancelItem = (e: any, itemIndex: number) => {
        e.preventDefault();

        var quoteItems = this.state.jobDetails.quoteItems;
        var quoteitemId = quoteItems[itemIndex].id;
        var itemId = quoteItems[itemIndex].itemId;
        this.setState({ showCancelModal: true, cancelIndexId: itemIndex, cancelQuoteItemId: quoteitemId, cancelItemId: itemId, cancelItem: quoteItems[itemIndex].item, cancelItemReasonId: -1 });
        
    }

    hideCancelModal = () => {
        this.setState({ showCancelModal: false, cancelIndexId: 0, cancelQuoteItemId: 0, cancelItemId: 0, cancelItem: "", cancelItemReasonId: -1 });
    }

    handleCancelReasonChange = (e: any) => {
        let errors: any = {};

        if (e.target.value < 0) {
            errors["cancelItemReasonId"] = "Valid Cancel Reason Required";
            this.setState({ errors: errors });
        } else {
            this.setState({ cancelItemReasonId: e.target.value, errors: {} });
        }
    }

    validateCancel = () => {
        let errors: any = {};

        if (this.state.cancelItemReasonId < 0) {
            errors["cancelItemReasonId"] = "Cancel Reason is required";
            this.setState({ errors: errors });
            return false;
        } else {
            return true;
        }
    }

    saveCancel = () => {
        if (this.validateCancel()) {
            //cancel the item 
            this.saveCancelJob();
        }
    }

    async saveCancelJob() {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        //update database
        var cancelItem = {
            jobQuoteItemId: this.state.cancelQuoteItemId,
            jobId: this.state.jobDetails.jobId,
            cancelReasonId: this.state.cancelItemReasonId,
            itemId: this.state.cancelItemId,
            item: this.state.cancelItem,
            subId: user.sub
        };

        axios.post('api/Job/CancelQuoteItemById', cancelItem, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            if (res.data == true) {
                toast.success("Item Cancelled");

                var jobDetails = this.state.jobDetails;
                var quoteItem = jobDetails.quoteItems[this.state.cancelIndexId];
                quoteItem.status = "Cancelled";

                this.setState({ jobDetails: jobDetails, showCancelModal: false, cancelIndexId: 0, cancelQuoteItemId: 0, cancelItemId: 0, cancelItem: "", cancelItemReasonId: -1 });

            } else {
                toast.error("There was an error cancelling the item, please refresh and try again!");
            }
        })
        .catch(error => {
            toast.error(error.message);
        });
    }
    //End Cancel Popup

    validate = () => {
        let formIsValid = true;
        let errors: any = {};

        if (this.state.goAheadId < 1) {
            formIsValid = false;
            errors["goAheadId"] = "Is the job going ahead is required";
        } else if (this.state.goAheadId == 3 && this.state.cancelReasonId < 1) {
            formIsValid = false;
            errors["cancelReasonId"] = "Cancel Reason is required";
        }

        this.setState({ errors: errors });
        return formIsValid;
    }

    submit = (e: any) => {
        e.preventDefault();
        if (this.validate()) {
            this.save();
        } else {
            //alert("Form has errors.")
        }

    }

    async save() {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        var details = {
            taskId: this.state.id,
            jobId: this.state.jobDetails.jobId,
            goAheadId: this.state.goAheadId,
            cancelReasonId: this.state.cancelReasonId,
            subId: user.sub
        };

        axios.post('api/Tasks/SaveFollowUpQuote', details, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            toast.success("Task Saved");
            this.props.history.push("/tasks")
        })
        .catch(error => {
            toast.error(error.message);
        });

    }

    public render() {
        let contents = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderDetails();

        return <div>
            <h1>Follow Up Quote</h1>
            {contents}
        </div>;
    }

    renderDetails = () => {
        var jobDetails = this.state.jobDetails;
        var phone = jobDetails.mobile != "" && jobDetails.phone != "" ? jobDetails.mobile + " or " + jobDetails.phone : jobDetails.mobile != "" ? jobDetails.mobile : jobDetails.phone;
        let cancelReasonOptions = this.state.cancelReasons;
        let taskJobDetails = <TaskJobDetails jobDetails={jobDetails} />

        return (
            <form name="jobDetails" onSubmit={this.submit}>
                <div className="static-modal">
                    <Modal show={this.state.showCancelModal} onHide={this.hideCancelModal}>
                        <Modal.Header className="modal__header--colour">
                            <Modal.Title>Cancel {this.state.cancelItem}</Modal.Title>
                            <button type="button" className="close" onClick={this.hideCancelModal}>&times;</button>
                        </Modal.Header>
                        <Modal.Body>
                            <div className="row">
                                <label className="input-group" htmlFor="cancelReason">
                                    <span className="label">Reason</span>
                                    <select className="select" id="cancelReason" name="cancelItemReasonId" value={this.state.cancelItemReasonId} onChange={(e) => this.handleCancelReasonChange(e)} >
                                        <option defaultValue="-1"></option>
                                        {cancelReasonOptions.map(reason =>
                                            <option key={reason.id} value={reason.id}>{reason.name}</option>
                                        )}
                                    </select>
                                </label>
                                <span className="label errors">{this.state.errors["cancelItemReasonId"]}</span>
                            </div>
                        </Modal.Body>

                        <Modal.Footer>
                            <button className="popup-button--yes" onClick={this.saveCancel}>Save</button>
                        </Modal.Footer>
                    </Modal>
                </div>
                <div>
                    <span>Please call {jobDetails.customerContact} from {jobDetails.customer} on {phone} to see if the below quote is going ahead:</span>
                    {taskJobDetails}
                    <div>
                        <div className="table__margin overflowAuto">
                            <table className="table table__large tableColours">
                                <thead>
                                    <tr>
                                        <th className="hidden">Id</th>
                                        <th>Item</th>
                                        <th>Status</th>
                                        <th>Hire Period</th>
                                        <th>Quantity</th>
                                        <th>Amount</th>
                                        <th>Overhire Rate</th>
                                        <th>Cancel</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {jobDetails.quoteItems.map((item, index) =>
                                        <tr key={index}>
                                            <td className="hidden">{item.id}</td>
                                            <td className="table__text--align">{item.item}</td>
                                            <td className="table__text--align">{item.status}</td>
                                            <td className="table__text--align">{item.hirePeriodDays}</td>
                                            <td className="table__text--align">{item.quantityMeasure}</td>
                                            <td className="table__text--align">{item.amountFormatted}</td>
                                            <td className="table__text--align">{item.overhireRateFormatted}</td>
                                            <td>
                                                <div className="delete--tablecell">
                                                    <a className="makeitred" href="#" onClick={(e) => this.cancelItem(e, index)}>
                                                        <span className="fas fa-times-circle edit--icon alignIconCenter"></span>
                                                    </a>
                                                </div>
                                            </td>
                                        </tr>

                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div>
                        <label htmlFor="goAheadId">
                            <span className="label tasks__labelsize">Are any items still going ahead?</span>
                            <select className="select" id="goAheadId" name="goAheadId" value={this.state.goAheadId} onChange={(e) => this.handleChange(e)}>
                                <option hidden defaultValue="-1"></option>
                                <option value="1">Yes - Going Ahead</option>
                                <option value="2">Pending</option>
                                <option value="3">No - Cancel Job</option>
                            </select>
                        </label>
                        <span className="label errors">{this.state.errors["goAheadId"]}</span>
                    </div>
                    <br></br>
                    <div className={this.state.goAheadId == 1 ? "" : "hidden"}>
                        <span>Please send through the go-ahead form so we are able to fully schedule your job.  In the meantime, we can tentatively schedule the job.</span>
                    </div>
                    <div className={this.state.goAheadId == 3 ? "" : "hidden"}>
                        <label className="input-group" htmlFor="cancelReasonId">
                            <span className="label">Cancel Reason</span>
                            <select className="select" id="cancelReasonId" name="cancelReasonId" value={this.state.cancelReasonId} onChange={(e) => this.handleChange(e)}>
                                <option hidden defaultValue="-1"></option>
                                {cancelReasonOptions.map(reason =>
                                    <option key={reason.id} value={reason.id}>{reason.name}</option>
                                )};
                            </select>
                        </label>
                        <span className="label errors">{this.state.errors["cancelReasonId"]}</span>
                    </div>
                    <br></br>
                    <div className="row">
                        <button className="defaultbutton-prev" type="submit">Save</button>
                    </div>
                </div>
            </form>
        );
    }
}
